import { DocType } from '../enums';

export class DocumentViewDialogDataInterface {
  documentNumber: string;
  minDateTime?: Date;
  maxDateTime?: Date;
  documentType: DocType;
}
